<div class="side-nav-content mt-3">
    <ul class="nav-list">
        @for (header of menuList; track header.menuHeaderId) {
        <!-- PARENT MENU -->
        <li class="nav-list-item parent-menu mt-2" [class.parent-active]="isParentActive(header)"
            (click)="toggleMenu(header.menuHeaderId)">
            <i class="fa-solid" [ngClass]="getParentIcon(header.menuHeaderName)"></i>
            <span class="icon-wrapper">
                {{header.menuHeaderName}}
            </span>
            <i class="fa-solid toggle-icon" [ngClass]="openedMenuIds.includes(header.menuHeaderId)
       ? 'fa-angle-down'
       : 'fa-angle-right'">
            </i>
        </li>
        <!-- SUB MENUS -->
        <ul class="submenu-list" [class.submenu-list-open]="openedMenuIds.includes(header.menuHeaderId)">
            @for (item of header.subMenuList; track item.menuId) {
            <li [ngClass]="{'nav-list-open': sideNavStatus}" class="nav-list-item submenu-item"
                (click)="onMenuClick(item)" [class.change]="item.menuName == activeItem">
                <i class="{{getMenuIcon(item.menuId)}}"></i>
                <span>
                    {{item.menuName}}
                </span>
            </li>
            }
        </ul>
        }
    </ul>
</div>
